import { cn } from "@/lib/utils"

interface DiagnosticContentProps {
  className?: string
  children: React.ReactNode
}

export default function DiagnosticContent({ className, children }: DiagnosticContentProps) {
  return <div className={cn("flex h-full w-full justify-center", className)}>{children}</div>
}
